import { selector } from 'recoil';

interface IConfig {
	API_ROOT: string;
	ORIGIN: string;
	CLIENT_ID: string;
	SIGNUP_ENABLED: boolean;
	FORGET_PASSWORD_ENABLED: boolean;
	PRIMARY_COLOR: string;
	PORTAL_ICON: string;
	PORTAL_BACKGROUND: string;
	APPROVAL_CHALLENGE_BYTES: number;
	APPROVAL_CHALLENGE_EXPIRES_IN: number;
	CONSENT_STATE_BYTES: number;
}

export const configState = selector<IConfig>({
	key: 'configCache',
	get: async (): Promise<IConfig> => {
		const response = await fetch('/config.json');
		const json = await response.text();
		return JSON.parse(json);
	},
});
